// Generated by CoffeeScript 1.12.7
(function () {
  module.exports = function (make, trial) {
    if (trial.shouldShowTrialEndModal()) {
      return trial.showTrialEndModal();
    }
  };
}.call(this));
